import { FadeIn } from "@/components/Reveal";

const ROW_ONE = [
  "Small Businesses",
  "Startups",
  "Growing Companies",
  "Contractors",
  "Employers",
  "Professional Service Firms",
];

const ROW_TWO = [
  "Property Management Companies",
  "Healthcare-Related Businesses",
  "Title & Escrow Companies",
  "Attorneys & Legal Offices",
  "Transportation & Logistics",
  "Organizations Managing Employees, Contractors, or Vendors",
];

const Seq = ({ items, hidden = false }) => (
  <div className="flex shrink-0 items-center gap-10 pr-10" aria-hidden={hidden}>
    {items.map((item) => (
      <span key={item} className="flex items-center gap-10">
        <span className="whitespace-nowrap font-serif text-3xl font-medium text-navy/85 lg:text-5xl">{item}</span>
        <span className="h-2.5 w-2.5 rotate-45 bg-gold" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const MarqueeRow = ({ items, reverse = false }) => (
  <div className="flex overflow-hidden">
    <div className={`flex w-max ${reverse ? "marquee-track-reverse" : "marquee-track"}`}>
      <Seq items={items} />
      <Seq items={items} hidden />
    </div>
  </div>
);

export const WhoWeServe = () => (
  <section id="who-we-serve" className="overflow-hidden bg-white py-24 lg:py-32">
    <div className="container-tsm">
      <FadeIn>
        <p className="eyebrow">Who We Serve</p>
        <h2
          className="mt-6 max-w-4xl font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl"
          data-testid="who-we-serve-headline"
        >
          Built for Businesses That Have More to Manage Than Time to Manage It
        </h2>
      </FadeIn>
    </div>

    <div className="mt-14 space-y-8 lg:mt-20 lg:space-y-12" data-testid="who-we-serve-marquee">
      <MarqueeRow items={ROW_ONE} />
      <MarqueeRow items={ROW_TWO} reverse />
    </div>
  </section>
);
